import { Button, Card, message, Modal, Progress, Space, Spin, Tag } from 'antd'
import React, { useState } from 'react'
import { DownloadFilesButton } from './LabResultsComponents'
import { processPdf } from '../community-hats-js-library/utils/labFunctions'
import * as libCon from "../community-hats-js-library/Constants.js"
import { RefParticipantsData } from '../hooks/DatasetHooks'
import { isNullOrUndefined, sleep } from '../community-hats-js-library/utils/generalFunctions'
import { uploadMapLabReportRecord } from '../community-hats-js-library/back-end/router'
import { formatExport } from '../community-hats-js-library/utils/dateFunctions'
import { uploadPDFToBucket } from '../community-hats-js-library/utils/uploadFunctions'
import { RefContextLanguage } from '../providers/LanguageProvider';


// Anything the presigned upload policy will not accept in an object key,
// replaced rather than dropped so two names cannot collapse into one.
const sanitizeForBucketKey = (name) => `${name}`.replace(/[^A-Za-z0-9._-]/g, '-')


function ExportMappedLabReports({ metadataForFiles, pdfFiles, mappingDict }) {

    const i18n = RefContextLanguage()

    const [participantStatus, participants] = RefParticipantsData()


    const [isUploading, setIsUploading] = useState(false)
    const [uploadProgress, setUploadProgress] = useState(0)


    // For uplaoding the files
    const [uploadedIds, setUploadedIds] = useState(null) // Files that did upload
    const [uploadingErrorIds, setUploadingErrorIds] = useState(null) // Files that did upload
    const [missingInUpload, setMissingInUploadFile] = useState(null) // Files missing from the mapping file


    const [showUploadedRecords, setShowUploadedRecords] = useState(false)
    const [showUploadingErrorRecords, setShowUploadingErrorRecords] = useState(false)
    const [showMissingInUploadRecords, setMissingInUploadRecords] = useState(false)



    const processMappingFile = async () => {

        setUploadProgress(0)
        setUploadedIds([])
        setMissingInUploadFile([])
        setUploadingErrorIds([])

        if (participantStatus !== libCon.OK)
            return

        // TODO
        // CHECK IF MISSING MAPPED PARTICIPANTS

        setIsUploading(true)


        let caseId = null

        let processedFiles = {}
        let i = 0;
        let total = Object.keys(mappingDict).length


        let newUploadedIds = []
        let newNotUploadedIds = Object.keys(metadataForFiles)
        let newUploadingErrorIds = []



        // Restarts 
        i = 0
        for (caseId in mappingDict) {

            let metadata = metadataForFiles[caseId]

            try {

                // Removes from missing
                newNotUploadedIds = newNotUploadedIds.filter(id => id !== metadata[libCon.ATF_CASE_ID])


                // Converts to String
                // Sewa Id
                let sewaId = mappingDict[caseId][libCon.ATF_SEWA_ID]
                if (!isNullOrUndefined(sewaId))
                    sewaId = `${sewaId}`

                const file = await processPdf(metadata[libCon.ATF_LAB], pdfFiles[caseId], sewaId);
                processedFiles[caseId] = file

                // Case Id
                if (!isNullOrUndefined(metadata[libCon.ATF_CASE_ID]))
                    metadata[libCon.ATF_CASE_ID] = `${metadata[libCon.ATF_CASE_ID]}`


                // The upload is presigned by the server, which pins the key and
                // will only sign one matching /^[A-Za-z0-9._-]+$/. formatExport
                // uses HH:mm:ss, so the colons have to go.
                let folder = `${libCon.LAB_RESULTS_FOLDER}/${sanitizeForBucketKey(sewaId)}`
                let filename = sanitizeForBucketKey(`${metadata[libCon.ATF_CASE_ID]}_${formatExport(metadata[libCon.ATF_SAMPLE_DATE])}.pdf`)


                // Uploads to Airtable
                let participantId = null
                let participant = Object.values(participants).find(p => p[libCon.ATF_SEWA_ID] === sewaId)
                if (!isNullOrUndefined(participant))
                    participantId = participant[libCon.ID]

                if (isNullOrUndefined(participantId)) {
                    console.error(`Could not find participant with sewa id ${sewaId}`)
                    newUploadingErrorIds.push(metadata[libCon.ATF_CASE_ID])
                    setUploadProgress(10 + (90 * i / total))
                    continue
                }


                let [airtableResponse, responseRecord] = await uploadMapLabReportRecord(participantId, metadata)

                if (airtableResponse !== libCon.OK || isNullOrUndefined(responseRecord)) {
                    console.error(`Could not add airtable mapping record for case: ${metadata[libCon.ATF_CASE_ID]}`)
                    newUploadingErrorIds.push(metadata[libCon.ATF_CASE_ID])
                    setUploadProgress(10 + (90 * i / total))
                    continue
                }

                // Uploads to Bucket 
                let bucketResponse = await uploadPDFToBucket(folder, filename, file)


                if (bucketResponse !== libCon.OK) {
                    console.error(`Error: Failed to upload ${filename} to bucket`)
                    newUploadingErrorIds.push(metadata[libCon.ATF_CASE_ID])
                    setUploadProgress(10 + (90 * i / total))
                    continue
                }


                // Adds to uploaded
                newUploadedIds.push(metadata[libCon.ATF_CASE_ID])
                setUploadProgress(100 * i / total)

                i++;

            } catch (error) {


                console.error(`Error procesing: ${metadata[libCon.ATF_CASE_ID]}. ${error}`)
                newUploadingErrorIds.push(metadata[libCon.ATF_CASE_ID])
                setUploadProgress(10 + (90 * i / total))
                continue

            }

        }



        setUploadedIds(newUploadedIds)
        setMissingInUploadFile(newNotUploadedIds)
        setUploadingErrorIds(newUploadingErrorIds)


        // Cleans Up
        setUploadProgress(100)
        setIsUploading(false)

        // Sleeps for sustainability
        await sleep(3000)

        message.success(i18n.t('done'));
    }


    return (

        <div>

            {/* Exporting Modals */}
            <Modal width={"70vw"}
                title={i18n.t('uploadedRecords')}
                open={showUploadedRecords}
                onCancel={() => setShowUploadedRecords(false)}
                footer={<DownloadFilesButton
                    pdfFiles={pdfFiles}
                    metadataForFiles={metadataForFiles}
                    keys={uploadedIds}
                    fileName={"uploaded_successfull.zip"} />}>
                {
                    !isNullOrUndefined(uploadedIds) && !isNullOrUndefined(metadataForFiles)
                        ? uploadedIds.map((key, i) => {
                            return (
                                <div key={i}>
                                    <p>{key}: {metadataForFiles[key][libCon.ATF_FILE_NAME]}</p>
                                </div>
                            )
                        }

                        )
                        : <div></div>
                }
            </Modal>


            {/* Missing Records */}
            <Modal width={"70vw"}
                title={i18n.t('missingInUpload')}
                open={showMissingInUploadRecords}
                onCancel={() => setMissingInUploadRecords(false)}
                footer={<DownloadFilesButton
                    pdfFiles={pdfFiles}
                    metadataForFiles={metadataForFiles}
                    keys={missingInUpload}
                    fileName={"missing_from_upload.zip"} />}>
                {
                    !isNullOrUndefined(missingInUpload) && !isNullOrUndefined(metadataForFiles)
                        ? missingInUpload.map((key, i) => {
                            return (
                                <div key={i}>
                                    <p>{key}: {metadataForFiles[key][libCon.ATF_FILE_NAME]}</p>
                                </div>
                            )
                        }

                        )
                        : <div></div>
                }
            </Modal>


            {/* Uploading errors */}
            <Modal width={"70vw"} title={i18n.t('uploadingErrors')} open={showUploadingErrorRecords} onCancel={() => setShowUploadingErrorRecords(false)} footer={null}>
                {
                    !isNullOrUndefined(uploadingErrorIds) && !isNullOrUndefined(metadataForFiles)
                        ? uploadingErrorIds.map((key, i) => {
                            return (
                                <div key={i}>
                                    <p>{key}: {metadataForFiles[key][libCon.ATF_FILE_NAME]}</p>
                                </div>
                            )
                        }

                        )
                        : <div></div>
                }
            </Modal>



            <Card style={{ width: "40vw", marginBottom: "10vh" }}
                styles={{ header: { backgroundColor: "var(--primary-color-3)" } }}
                type="inner" size="medium" title={i18n.t('uploadMappingFile')}>

                {/* Main Button */}

                {
                    isUploading
                        ? <Spin />
                        : <Button
                            type="primary"
                            style={{ marginTop: "10px" }}
                            onClick={processMappingFile}>
                            Export Mapped Results
                        </Button>
                }



                {
                    uploadProgress === 100
                        ? <div>
                            <Space direction="horizontal">
                                <Tag onClick={() => setShowUploadedRecords(true)} color="green" style={{ marginTop: "10px", fontSize: '16px', padding: '6px 12px' }}>{i18n.t('uploadedLabel')}: {uploadedIds.length} </Tag>
                                <Tag onClick={() => setMissingInUploadRecords(true)} color="gold" style={{ marginTop: "10px", fontSize: '16px', padding: '6px 12px' }}>{i18n.t('missingInUpload')}: {missingInUpload.length}</Tag>
                                <Tag onClick={() => setShowUploadingErrorRecords(true)} color="red" style={{ marginTop: "10px", fontSize: '16px', padding: '6px 12px' }}>{i18n.t('withError')}: {uploadingErrorIds.length}</Tag>

                            </Space>
                        </div>
                        : <div style={{ height: "30px" }}></div>
                }


                <Progress style={{ width: "100%" }} percent={uploadProgress} status='success' />

            </Card>


        </div >
    )
}

export default ExportMappedLabReports